import {
    HOME,
    HOME_DIAGNOSTIC_FILTER_LIST,
    HOME_DIAGNOSTIC_ID,
    HOME_DIAGNOSTIC_LIST,
    HOME_DISPLAY_TILES,
    HOME_ERROR,
    HOME_DISPLAY_DIAGNOSTICS,
    HOME_ORBIT_ID,
    HOME_ORBIT_LIST,
    HOME_DEFAULT_ORBIT,
    INITIAL_TOP_NAV_DISPLAY,
    NAVIGATE_TO_HOME_PAGE,
    TERMS_CONDITIONS_COMPLETED,
    REFRESH_TILE_ATTRIBUTE_LIST,
    HOME_SERVICE_LINE_LIST,
    HOME_SERVICE_LINE_ID,
    HOME_DISPLAY_SERVICE_LINE,
    HOME_ORGANIZATION_LIST,
    HOME_ORGANIZATION_ID,
    HOME_DISPLAY_ORBIT,
    HOME_DISPLAY_ORGANIZATION, SET_HIDE_TOP_NAV, SELECT_ORBIT_HOME, SET_VIEWED_WELCOME_MESSAGE, SET_WELCOME_MESSAGE
} from "../actions/types";
import {setRefreshTileAttributeList} from "../actions/home.js";

const INITIAL_STATE = {
    errorMessage: '',
    tileAttributes: [],
    diagnosticId: [],
    diagnosticList: [],
    diagnosticFilterList: [],
    clusterType: '',
    useFlexContainer: false,
    displayDiagnostics: false,
    displayTiles: false,
    displayServiceLine: false,
    displayOrbit: false,
    displayOrganization: false,
    orbitHome: false,
    orbitId: [],
    orbitList: [],
    defaultOrbit: [],
    clusterCssArray: [],
    initialTopNavDisplay: false,
    navigateToHomePage: false,
    termsConditionsCompleted: false,
    refreshTileAttributeList: false,
    serviceLineId: null,
    serviceLineList: null,
    organizationId: null,
    organizationList: [],
    hideTopNav: true,
    welcomeMessage: null,
    viewedWelcomeMessage: false
};

export const homeReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case HOME:
            return {
                ...state,
                errorMessage: '',
                tileAttributes: action.payload.tileAttributes,
                clusterType: action.payload.clusterType,
                useFlexContainer: action.payload.useFlexContainer,
                clusterCssArray: action.payload.clusterCssArray
            };

        case SELECT_ORBIT_HOME:
            return {
                ...state,
                orbitHome: action.payload.orbitHome,
            }

        case SET_VIEWED_WELCOME_MESSAGE:
            return {
                ...state,
                viewedWelcomeMessage: action.payload.viewedWelcomeMessage,
            }

        case SET_WELCOME_MESSAGE:
            return {
                ...state,
                welcomeMessage: action.payload.welcomeMessage,
            }

        case HOME_DIAGNOSTIC_LIST:
            return {
                ...state,
                diagnosticList: action.payload.diagnosticList
            }

        case HOME_SERVICE_LINE_LIST:
            return {
                ...state,
                serviceLineList: action.payload.serviceLineList
            }

        case TERMS_CONDITIONS_COMPLETED:
            return {
                ...state,
                termsConditionsCompleted: action.payload.termsConditionsCompleted
            }

        case HOME_DEFAULT_ORBIT:
            return {
                ...state,
                defaultOrbit: action.payload.defaultOrbit
            }

        case HOME_SERVICE_LINE_ID:
            return {
                ...state,
                serviceLineId: action.payload.serviceLineId
            }

        case HOME_ORBIT_ID:
            return {
                ...state,
                orbitId: action.payload.orbitId
            }

        case HOME_DISPLAY_TILES:
            return {
                ...state,
                displayTiles: action.payload.displayTiles
            }

        case HOME_DISPLAY_SERVICE_LINE:
            return {
                ...state,
                displayServiceLine: action.payload.displayServiceLine
            }

        case HOME_DISPLAY_ORBIT:
            return {
                ...state,
                displayOrbit: action.payload.displayOrbit
            }

        case SET_HIDE_TOP_NAV:
            return {
                ...state,
                hideTopNav: action.payload.hideTopNav
            }

        case HOME_DISPLAY_ORGANIZATION:
            return {
                ...state,
                displayOrganization: action.payload.displayOrganization
            }

        case HOME_ORBIT_LIST:
            return {
                ...state,
                orbitList: action.payload.orbitList
            }

        case HOME_ORGANIZATION_LIST:
            return {
                ...state,
                organizationList: action.payload.organizationList
            }

        case HOME_ORGANIZATION_ID:
            return {
                ...state,
                organizationId: action.payload.organizationId
            }

        case HOME_DISPLAY_DIAGNOSTICS:
            return {
                ...state,
                displayDiagnostics: action.payload.displayDiagnostics
            }

        case HOME_DIAGNOSTIC_FILTER_LIST:
            return {
                ...state,
                diagnosticFilterList: action.payload.diagnosticFilterList
            }

        case HOME_DIAGNOSTIC_ID:
            return {
                ...state,
                diagnosticId: action.payload.diagnosticId
            }

        case NAVIGATE_TO_HOME_PAGE:
            return {
                ...state,
                navigateToHomePage: action.payload.navigateToHomePage
            }

        case INITIAL_TOP_NAV_DISPLAY:
            return {
                ...state,
                initialTopNavDisplay: action.payload.initialTopNavDisplay
            }

        case REFRESH_TILE_ATTRIBUTE_LIST:
            return {
                ...state,
                refreshTileAttributeList: action.payload
            }

        case HOME_ERROR:
            return {
                ...state,
                errorMessage: action.payload
            };

        default:
            return state;
    }
};
